import React from 'react';
import Link from 'next/link';

export default function Title (props) {
  const title = props.title || props.text || 'TITLE';
  const desc = props.desc || '';

  // 관련콘텐츠 영역 등 조건에 따라 보이지 않는케이스가 있어 aria-label만 적용
  // 스크린리더에 따라 포커스가지 않을 수 있음
  return (
    <div className='module_titleline_w' tabIndex={props.view || props.view === undefined ? '0' : '-1'} aria-label={title}>
      <h3 className='module_titleline_title'>{title}</h3>
      {props.link && props.link.charAt(0) === '/' && (<Link href={`${props.link}`}>
        <a className='module_titleline_link'>
          {desc}
        </a>
                                                      </Link>)}
      {props.link && props.link.charAt(0) !== '/' && (<a href={`${props.link}`} className='module_titleline_link'>
        {desc}
                                                      </a>)}
      {/* 이벤트 일시 전체 이동하기 버튼 추가 */}
      {props.mainContentsType === 'event' && (<a href='/event' className='module_titleline_link'>전체보기</a>)}
      
      {/* 프리미엄뉴스 일시 전체 이동하기 버튼 추가 */}
      {props.type === 'pnews' && (<a href='https://premium.sbs.co.kr/?utm_source=sbsmain' target='_blank' className='module_titleline_link'>전체보기</a>)}
    </div>
  );
}
